/**
 * カラー定数
 * frontend/styles/_variables.scss の変数と同期すること。
 * TSXファイルからはこのファイルを経由して色を参照する。
 */

export const colors = {
  // プライマリ（_variables.scss: $primary 系）
  primary:       "#FF9100",
  primaryDark:   "#F5C11C",
  primaryLight:  "#FFF3E0",
  primaryYellow: "#FFFF00",

  // ベース（_variables.scss: $white）
  white: "#ffffff",

  // グレースケール（_variables.scss: $gray-* 系）
  gray50:  "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray800: "#1f2937",
  gray900: "#111827",

  // チャート複数系列（_variables.scss: $chart-* 系）
  chartSecondary: "#3b82f6",
  chartTertiary:  "#10b981",

  // オーディエンス性別（_variables.scss: $chart-female / $chart-male）
  chartFemale: "#ec4899",
  chartMale:   "#3b82f6",

  // セマンティック（_variables.scss: $success / $error）
  success: "#22c55e",
  error:   "#ef4444",
} as const

// 複数アカウントのグラフ系列色（DESIGN.md の色域から選定）
const ACCOUNT_CHART_PALETTE = [
  { border: "#FF9100", bg: "rgba(255, 145,   0, 0.15)" }, // primary orange
  { border: "#3b82f6", bg: "rgba( 59, 130, 246, 0.15)" }, // chartSecondary blue
  { border: "#10b981", bg: "rgba( 16, 185, 129, 0.15)" }, // chartTertiary green
  { border: "#F5C11C", bg: "rgba(245, 193,  28, 0.15)" }, // primaryDark gold
  { border: "#8b5cf6", bg: "rgba(139,  92, 246, 0.15)" }, // violet
  { border: "#06b6d4", bg: "rgba(  6, 182, 212, 0.15)" }, // cyan
] as const

export const getAccountChartColor = (index: number) =>
  ACCOUNT_CHART_PALETTE[index % ACCOUNT_CHART_PALETTE.length]
